import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'
export default {
    namespaced: true,
    state() {
        return {
            mfpNumbers: []
        }
    },
    getters: {
        getMfpNumbers: state => state.mfpNumbers
    },
    mutations: {
        setMfpNumbers(state, data) {
            state.mfpNumbers = data
        }
    },
    actions: {
        getMfpNumbers({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                Api.MfpNumbers.getMfpNumbers(data)
                    .then(response => {
                        commit('setMfpNumbers', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        }
    }
}